import React from 'react';
import { motion } from 'framer-motion';
import { systemParts } from '../data/offer';
export function SystemBreakdown() {
  return <section className="border-y border-acad-line bg-acad-ink px-4 py-20 sm:py-24" data-id="element-200" data-mp="t5xg8oa7hxiv">
      <div className="mx-auto max-w-5xl" data-id="element-201" data-mp="odnjopel5z7m">
        <div className="mx-auto max-w-3xl text-center" data-id="element-202" data-mp="occeqm9emlex">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-203" data-mp="jej6zosgdjcj">
            This is why it is a true 6-in-1 system
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-white sm:text-5xl" data-id="element-204" data-mp="9hek1mqs9juo">
            Six parts of the same teaching methodology
          </h2>
          <p className="mt-4 text-base leading-7 text-white/70" data-id="element-205" data-mp="5gcu5wirak5d">
            You are not receiving six disconnected books. You are receiving six
            parts of one system, in the order your students actually develop.
          </p>
        </div>

        <ol className="mt-14 space-y-4" data-id="element-206" data-mp="1uv0xl89dcrr9">
          {systemParts.map((part, index) => <motion.li key={part.number} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.26,
          delay: Math.min(index, 5) * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-5 border-b border-white/10 pb-5 last:border-0" data-id="element-207" data-mp="1f7jsa0rcciv3" data-mpi={index}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-acad-gold/60 font-display text-lg font-semibold text-acad-gold" data-id="element-208" data-mp="1p6987nzoft8p">
                {part.number}
              </span>
              <div data-id="element-209" data-mp="2htn21d82w8ol">
                <h3 className="text-sm font-bold uppercase tracking-[0.12em] text-white" data-id="element-210" data-mp="2ht3pyd540eih">
                  {part.title}
                </h3>
                <p className="mt-1.5 text-base leading-7 text-white/70" data-id="element-211" data-mp="2whncpzy3uvw4">
                  {part.description}
                </p>
              </div>
            </motion.li>)}
        </ol>

        <p className="mt-12 text-center font-display text-2xl font-semibold text-acad-gold sm:text-3xl" data-id="element-212" data-mp="2mio58kp2t6ap">
          Six teaching needs. One complete system.
        </p>
      </div>
    </section>;
}